"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.CommonLoader = void 0;

var _loader = _interopRequireDefault(require("./components/loader"));

exports.CommonLoader = _loader["default"];